export const DatabaseIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12 6.5C13.9001 6.5 15.6018 6.7205 16.8125 7.06641C17.4211 7.24031 17.8773 7.43811 18.1699 7.63574C18.48 7.84519 18.5 7.97761 18.5 8C18.5 8.02239 18.48 8.15481 18.1699 8.36426C17.8773 8.56189 17.4211 8.75969 16.8125 8.93359C15.6018 9.2795 13.9001 9.5 12 9.5C10.0999 9.5 8.39818 9.2795 7.1875 8.93359C6.57887 8.75969 6.12269 8.56189 5.83008 8.36426C5.52001 8.15481 5.5 8.02239 5.5 8C5.5 7.97761 5.52001 7.84519 5.83008 7.63574C6.12269 7.43811 6.57887 7.24031 7.1875 7.06641C8.39818 6.7205 10.0999 6.5 12 6.5Z'
        stroke='currentColor'
      />
      <path
        d='M18.5 12C18.5 13.1046 15.5899 14 12 14C8.41015 14 5.5 13.1046 5.5 12'
        stroke='currentColor'
      />
      <path
        d='M5.5 8V16.6633C5.5 17.6777 8.41015 18.5 12 18.5C15.5899 18.5 18.5 17.6777 18.5 16.6633V8'
        stroke='currentColor'
      />
    </svg>
  )
}
